export default {
  // 登錄、註冊
  login: {
    login: '登錄',
    regist: '註冊',
    test: '登錄、註冊',
    pwdlogin: '密碼登錄',
    qrlogin: '掃碼登錄',
    pwd: '密碼',
    remember: '壹周內自動登錄',
    forgetPwd: '忘記密碼',
    loginBtn: '登 錄',
    downApp: '下載移動端',
    website: '訪問官網',
    qrNote1: '請使用',
    qrNote2: '平台移動端掃描二維碼登錄',
    userRegist: '用戶註冊',
    registAccount: '註冊賬號',
    vCode: '驗證碼',
    getCode: '獲取驗證碼',
    agree: '我已同意',
    clause: '服務條款',
    clause_err: '請同意服務條款，以及隱私政策！',
    nextStep: '下壹步',
    pwdlogint: '已有賬號',
    pwdloginy: '立即登錄',
    rememberpwd: '想起密碼了',
    NOUser: '沒有賬號？',
    resetPwd: '重置密碼 ',
    loginPhone: '登錄手機號碼 ',
    thank: '感謝您的註冊 ',
    note: '相關同事將會對您的信息進行審核，審核通過後會以短信的形式通知到您。 ',
    ok: '好的 ',
    continues: '請完成下列驗證後繼續 ',
    verifySuccess: '驗證成功 ',
    dragPuzzle: '按在左邊按鈕拖動完成上方拼圖 ',
    refurbish: '刷新 ',
    wait: ' 註冊中，請稍等 ',
    regain: '後重新獲取',
    or: '或',
    thirdpartyscancodelogin: '第三方掃碼登錄',
    userthirdpartyscancodelogin: '使用第三方賬號登錄',
    teamfacewechat: '微信公眾號',
    followwechatpublicaccount: '關註微信公眾號',
    clicknexttoagree: '點擊下壹步即代表同意',
    returntologinscreen: '返回登錄界面',
    teamfacescancodelogin: '掃碼登錄',
    loginsuccess: '登錄成功',
    enterprisewechat: '企業微信',
    nail: '釘釘',
    thirdpartylogin: '第三方登錄',
    chromeisrecommended: '建議使用穀歌瀏覽器',
    invalid: '二維碼失效',
    placeholder1: '手機號碼/郵箱/工號',
    placeholder2: '手機號碼/郵箱',
    placeholder: {
      company: '公司名稱（必填）',
      name: '姓名（必填）',
      pwd: '登錄密碼（必填）',
      realm: '公網域名或IP（包含端口且必填）',
      im: '請輸入公網域名或IP，用於IM使用'
    },
    error: {
      company: '公司名稱最少4位',
      company_empty: '公司名稱不能為空',
      name_empty: '姓名不能為空',
      pwd: '密碼至少6位',
      pwd_empty: '密碼不能為空',
      realm: '地址格式不正確',
      realm_empty: '地址不能為空',
      im: 'IM地址格式不正確',
      im_empty: 'IM地址不能為空',
      user: '賬戶格式錯誤'
    },
    service: {
      header: '服務條款',
      header1: '壹、特別聲明',
      header2: '二、用戶條款',
      header3: '三、知識產權聲明',
      header4: '四、用戶信息保護',
      header5: '五、有效通知',
      header6: '六、免責聲明',
      header7: '七、服務的修改與信息披露',
      header8: '八、法律管轄',
      header9: '隱私政策',
      header10: '我們可能收集的信息',
      header11: '您提供的信息',
      header12: '我們獲取的您的信息',
      header13: '我們可能如何使用信息',
      header14: '您如何訪問和控制自己的個人信息',
      header15: '我們可能分享的信息',
      header16: '法定披露',
      header17: '信息安全',
      header18: '您分享的信息',
      header19: '您分享的敏感個人信息',
      header20: '您同意按本《隱私政策》所述的目的和方式來處理您的敏感個人信息。',
      header21: '我們可能如何收集信息',
      header22: '我們可能向您發送的郵件和信息',
      header23: '郵件和信息推送',
      header24: '與服務有關的公告',
      header25: '隱私政策的適用範圍',
      header26: '請您註意，本《隱私政策》不適用於以下情況：',
      header27: '變更',

      ol1: '1、TeamFace是由深圳市匯聚華企科技有限公司提供，用戶必須完全同意所有服務條款才能註冊使用。用戶在完成全部激活註冊程序後，即代表您已充分閱讀、理解並接受本條款的全部內容， 本條款即產生法律約束力。您承諾接受並遵守本條款的約定，屆時您不應以未閱讀本條款的內容或者未獲得對您問詢的解答等理由，主張本條款無效，或要求撤銷本條款。',
      ol2: '2、TeamFace有權根據業務需要酌情修訂"條款"，並在其網站上予以公告。如用戶不同意相關修訂，請用戶立即停止使用本服務。經修訂的"條款"壹經在網站公布，即產生效力。如用戶繼續使用TeamFace，則將視為用戶已接受經修訂的"條款"，當用戶與TeamFace發生爭議時，應以最新的"條款"為準。',
      ol3: '1、服務條款是TeamFace與用戶之間的協議，此條款在必要時將進行修訂，修訂後的條款、規則壹旦公布即取代原服務條款內容及規則並自動生效。如您不同意相關變更，應當立即停止使用TeamFace，如您繼續使用，即表示您已接受經修訂的服務和規則。',
      ol4: '2、TeamFace向用戶提供的基於阿裏雲的企業服務雲平臺，幫助用戶實現基於雲計算的協同互聯網服務，服務包括手機客戶端（iOS、Android等）、電腦WEB端等多個應用版本的應用服務，用戶必須選擇與所安裝終端設備相匹配的軟件版本。',
      ol5: '3、用戶在使用TeamFace過程中，必須遵循以下規則：',
      ol6: '5、如用戶在使用本網站服務時違反任何上述規定，”匯聚華企”有權要求用戶改正或直接采取壹切必要的措施（包括但不限於暫停或終止用戶使用本服務的權利並追討因此帶來的損失）以減輕用戶不當行為造成的影響。',
      ol7: '6、用戶須對在TeamFace的註冊信息的真實性、合法性、有效性承擔全部責任，用戶不得冒充他人；不得利用他人的名義發布任何信息；不得惡意使用註冊帳戶導致其他用戶誤認；否則“匯聚華企”有權立即停止提供服務，收回其帳號並由用戶獨自承擔由此而產生的壹切法律責任。',
      ol8: '7、用戶直接或通過各類方式（如 RSS 源和站外 API 引用等）間接使用本服務和數據的行為，都將被視作已無條件接受本協議全部內容；若用戶對本協議的任何條款存在異議，請停止使用TeamFace所提供的全部服務。',
      ol9: '8、用戶承諾不得以任何方式利用TeamFace直接或間接從事違反中國法律、以及社會公德的行為，TeamFace有權對違反上述承諾的內容予以刪除。',
      ol10: '9、用戶不得利用本服務制作、上載、復制、發布、傳播或者轉載如下內容：',
      ol11: '10、TeamFace有權對用戶使用情況進行審查和監督，如用戶在使用時違反任何上述規定，TeamFace或其授權的人有權要求用戶改正或直接采取壹切必要的措施（包括但不限於更改或刪除用戶張貼的內容、暫停或終止用戶使用本服務的權利）以減輕用戶不當行為造成的影響',
      ol12: '11、TeamFace有權但無義務對用戶發布的內容進行審核，有權根據相關證據結合《侵權責任法》、《信息網絡傳播權保護條例》等法律法規及TeamFace社區指導原則對侵權信息進行處理。',
      ol13: '1、TeamFace的應用程序、源代碼、商標、LOGO、界面設計、應用程序編程接口(API)等所關聯的所有知識產權均屬深圳市匯聚華企科技有限公司（下面簡稱“我公司”）所有。上述及其他任何本服務包含的內容的知識產權均受到法律保護，未經我公司或相關權利人書面許可，任何人不得以任何形式進行非法使用。',
      ol14: '2、用戶應當確保其公開或存儲TeamFace相關服務器的內容不存在任何侵犯其他第三方知識產權的情形。若存在本條所述情形，我公司有權根據具體情節針對上述內容，采取包括但不限於限制、屏蔽、刪除、修改等手段，由此給網站用戶造成的損失由用戶自行承擔；若我公司因用戶存在本條所述行為而向其他第三方承擔法律責任的，我公司有權向用戶追償全部損失。',
      ol15: '1、TeamFce將盡可能采取壹切措施保護用戶數據及個人信息資料安全，只根據用戶的行為指示來分發用戶的信息，不會向任何第三方公開或共享用戶的具體數據。',
      ol16: '2、TeamFace保留使用匯總統計性信息的權利，在不透露單個用戶隱私資料的前提下，有權對整個用戶數據庫進行分析並對用戶數據庫進行商業上的利用。',
      ol17: 'TeamFace向您發出的任何通知，可采用電子郵件、用戶網絡區域提示，手機短信或常規信件等方式，且該等通知應自發送之日視為已向用戶送達生效。',
      ol18: '1、您理解並同意，在使用TeamFace的過程中，可能會遇到不可抗力等風險因素，使本服務發生中斷。 不可抗力是指不能預見、不能克服並不能避免且對壹方或雙方造成重大影響的客觀事件， 包括但不限於由於自然災害、網絡連接故障、黑客、病毒、通訊、電力或其它系統的故障、罷工、勞動爭議、戰爭、動亂、政府行為及等。出現上述情況時，TeamFace將努力在第壹時間與相關單位配合，及時進行修復，但是由此給您造成的損失TeamFace均不承擔責任。',
      ol19: '2、妳理解並同意TeamFace將會盡其商業上的合理努力，保障您在本軟件及服務中的數據存儲安全；但是並不能就此提供完全保證，包括但不限於以下情形：',
      ol20: '3、用戶在使用本軟件及服務時，須自行承擔如下TeamFace不可掌控的風險內容，包括但不限於：',
      ol21: '1、本協議的生效、解釋、執行、管轄、爭議的解決均應適用中華人民共和國法律。',
      ol22: '2、如發生TeamFace服務條款與中國法律相抵觸時，則這些條款將完全按法律規定重新解釋，而其它合法條款則依舊保持對用戶產生法律效力和影響。',
      ol23: '3、因本協議引起的或與本協議有關的任何爭議，雙方可友好協商解決；協商不成，任何壹方均可在深圳市南山區人民法院提起訴訟。',
      li1: '遵守中國有關的法律法規；',
      li2: '不得對本網站服務進行任何形式的對其他第三方的再授權使用、銷售或轉讓；',
      li3: '不得為設計開發競爭產品對本網站進行任何形式的反向工程、反向編譯、反匯編，或在競爭產品抄襲模仿本服務產品的設計；',
      li4: '不得濫用TeamFace通信功能發送垃圾郵件和短信；',
      li5: '不得對TeamFace的連續服務和商譽構成損害的其他行為，包括對服務器的攻擊；',
      li6: '遵守本協議中的全部約定。',
      li7: '危害國家安全，泄露國家秘密，顛覆國家政權，破壞國家統壹的；',
      li8: '損害國家榮譽和利益的；',
      li9: '煽動民族仇恨、民族歧視，破壞民族團結的；',
      li10: '破壞國家宗教政策，宣揚邪教和封建迷信的；',
      li11: '散布謠言，擾亂社會秩序，破壞社會穩定的；',
      li12: '散布淫穢、色情、賭博、暴力、兇殺、恐怖或者教唆犯罪的；',
      li13: '侮辱或者誹謗他人，侵害他人合法權益的；',
      li14: '含有法律、行政法規禁止的其他內容的信息。',
      li15: '我公司不對妳在本軟件及服務中誤刪數據或儲存失敗負責，但我們會盡力協助用戶處理以減少因此給用戶造成的損失和影響。',
      li16: 'Teamface有權根據實際情況自行決定單個用戶在本軟件及服務中數據的最長儲存期限，並在服務器上為其分配數據最大存儲空間等。妳可根據自己的需要自行備份本軟件及服務中的相關數據；',
      li17: '如果妳停止使用本軟件及服務或服務被終止或取消，TeamFace可以從服務器上永久地刪除妳的數據。服務停止、終止或取消後，TeamFace沒有義務向妳返還任何數據。',
      li18: '由於不可抗拒因素可能引起的個人信息丟失、泄漏等風險；',
      li19: '用戶必須選擇與所安裝終端設備相匹配的軟件版本，否則，由於軟件與終端設備型號不相匹配所導致的任何問題或損害，均由用戶自行承擔；',
      li20: '用戶在使用本軟件訪問第三方網站時，因第三方網站及相關內容所可能導致的風險，由用戶自行承擔；',
      li21: '用戶發布的內容被他人轉發、分享，因此等傳播可能帶來的風險和責任；',
      li22: '由於無線網絡信號不穩定、無線網絡帶寬小等原因，所引起的登錄失敗、資料同步不完整、頁面打開速度慢等風險。',
      li23: '妳在使用本軟件第三方提供的產品或服務時，除遵守本協議約定外，還應遵守第三方的用戶協議。TeamFace和第三方對可能出現的糾紛在法律規定和約定的範圍內各自承擔責任。',
      li24: '醫療設施、交通通訊等重要領域。如果因為軟件或服務的原因導致上述操作失敗而帶來的人員傷亡、財產損失和環境破壞等，TeamFace不承擔法律責任。',

      content1: '尊敬的用戶：',
      content2:
        '歡迎使用TeamFace ，為了使您獲得愉悅和安全的服務，在此列明以下服務條款，在使用本服務之前，請您務必審慎閱讀、充分理解。',
      content3:
        '如發生下列任何壹種情形，TeamFace有權不經通知而中斷或終止向您提供的服務，並對相關內容進行保存或披露：',
      content4: '1、您違反相關法律法規或本協議的約定。',
      content5: '2、按照法律規定或主管部門的要求。',
      content6: '3、為保護TeamFace用戶及社會公眾的權利、財產或人身安全。',
      content7: '4、其他出於安全的原因或其他必要的情況。',
      content8: '尊敬的用戶，歡迎您使用TeamFace !',
      content9:
        'TeamFace是由深圳市匯聚華企科技有限公司（以下簡稱“匯聚華企”）提供，匯聚華企認可並重視用戶的隱私，隱私權是您重要的權利。您在使用TeamFace服務時，我們可能會收集和使用您的相關信息。我們希望通過本《隱私政策》向您說明。希望您仔細閱讀，在需要時，按照本《隱私政策》的指引，作出您認為適當的選擇。',
      content10:
        '您使用或繼續使用我們的服務，即意味著同意我們按照本《隱私政策》收集、使用、儲存和分享您的相關信息。如對本《隱私政策》或相關事宜有任何問題，請通過TeamFace官網聯系方式與我們聯系。',
      content11:
        '我們提供服務時，可能會收集、儲存和使用下列與您有關的信息。如果您不提供相關信息，可能無法註冊成為我們的用戶或無法享受我們提供的某些服務，或者無法達到相關服務擬達到的效果。',
      content12:
        '您在註冊TeamFace賬戶或使用時，向我們提供的相關信息，個人信息包括：姓名、電話號碼、電子郵件、公司/團隊信息包括：公司名稱、LOGO、聯系方式等以及您在購買服務過程中可能涉及到的帳戶信息；',
      content13: '您通過TeamFace向其他方提供的共享信息，以及您使用我們的服務時所儲存的信息。',
      content14: '您使用TeamFace時我們可能收集如下信息：',
      content15: 'WEB信息',
      content16:
        '指您使用TeamFace時，我們的WEB服務器會自動采集和匯總有關您的訪問信息，包括：相關網頁的URL或域、系統及相關軟件信息，您所訪問的頁面及訪問日期和時間等。',
      content17: '位置信息',
      content18:
        '指您開啟設備定位功能並使用我們基於位置提供的相關服務時，收集的有關您位置的信息，包括：',
      content19:
        '1)您通過具有定位功能的移動設備使用我們的服務時，通過GPS或WiFi等方式收集的您的地理位置信息；',
      content20:
        '2)您或其他用戶提供的包含您所處地理位置的實時信息，例如您提供的賬戶信息中包含的您所在地區信息，您或其他人上傳的顯示您當前或曾經所處地理位置的共享信息，您或其他人共享的照片包含的地理標記信息；',
      content21: '3)您可以通過關閉定位功能，停止對您的地理位置信息的收集。',
      content22: '我們可能將在向您提供服務的過程之中所收集的信息用作下列用途：',
      content23: '1)向您提供服務。',
      content24:
        '2)在我們提供服務時，用於身份驗證、客戶服務、安全防範、詐騙監測、存檔和備份用途，確保我們向您提供的產品和服務的安全性。',
      content25:
        '3)幫助我們設計新服務，改善我們現有服務，使我們更加了解您如何接入和使用我們的服務，從而評估並增強您對TeamFace的體驗感，包括通過識別您的喜好和購習意向，進行營銷以及與運營和開發相關的活動。',
      content26: '4)軟件認證或管理軟件升級，讓您參與有關我們產品和服務的調查。',
      content27:
        '為了讓您有更好的體驗、改善我們的服務或您同意的其他用途，在符合相關法律法規的前提下，我們可能將通過某壹項服務所收集的信息，以匯集信息或者個性化的方式，用於我們的其他服務。例如，在您使用我們的壹項服務時所收集的信息，可能在另壹服務中用於向您提供特定內容，或向您展示與您相關的、非普遍推送的信息。如果我們在相關服務中提供了相應選項，您也可以授權我們將該服務所提供和儲存的信息用於我們的其他服務。',
      content28:
        '我們將盡壹切可能采取適當的技術手段，保證您可以訪問、更新和更正自己的註冊信息或使用我們的服務時提供的其他個人信息。在訪問、更新、更正和刪除前述信息時，我們可能會要求您進行身份驗證，以保障賬戶安全。',
      content29:
        '除以下情形外，未經您同意，我們以及我們的關聯公司不會與任何第三方分享您的個人信息。',
      content30:
        '我們以及我們的關聯公司，可能將您的個人信息與我們的關聯公司、合作夥伴及第三方服務供應商、承包商及代理（例如代表我們發出電子郵件或推送通知的通訊服務提供商、為我們提供位置數據的地圖服務供應商）分享（他們可能並非位於您所在的地域），用作下列用途：',
      content31: '1)向您提供我們的服務；',
      content32: '2)實現“ 我們可能如何使用信息 ”部分所述目的；',
      content33: '3)理解、維護和改善我們的服務。',
      content34:
        '如我們或我們的關聯公司與任何上述第三方分享您的個人信息，我們將努力確保該等第三方在使用您的個人信息時遵守本《隱私政策》及我們要求其遵守的其他適當的保密和安全措施。',
      content35:
        '隨著我們業務的持續發展，我們以及我們的關聯公司有可能進行合並、收購、資產轉讓或類似的交易，您的個人信息有可能作為此類交易的壹部分而被轉移。我們將在轉移前通知您。',
      content36: '我們或我們的關聯公司還可能為以下需要而保留、保存或披露您的個人信息：',
      content37: '1)遵守適用的法律法規；',
      content38: '2)遵守法院命令或其他法律程序的規定；',
      content39: '3)遵守相關政府機關的要求。',
      content40:
        '為遵守適用的法律法規、維護社會公共利益，或保護我們的客戶、我們或我們的集團公司、其他用戶或雇員的人身和財產安全或合法權益所合理必需的用途。',
      content41:
        '我們僅在本《隱私政策》所述目的所必需的期間和法律法規要求的時限內保留您的個人信息。',
      content42:
        '我們使用各種安全技術和程序，以防信息的丟失、不當使用、未經授權閱覽或披露。例如，在某些服務中，我們將利用加密技術（例如SSL）來保護您提供的個人信息。但請您理解，由於技術的限制以及可能存在的各種惡意手段，在互聯網行業，即便竭盡所能加強安全措施，也不可能始終保證信息百分之百的安全。您需要了解，您接入我們的服務所用的系統和通訊網絡，有可能因我們可控範圍外的因素而出現問題。',
      content43:
        '我們的多項服務，可讓您不僅與自己的社交網絡，也與使用該服務的所有用戶公開分享您的相關信息，例如，您在我們的服務中所上傳或發布的信息（包括您公開的個人信息、您建立的名單）、您對其他人上傳或發布的信息作出的回應，以及包括與這些信息有關的位置數據和日誌信息。使用我們服務的其他用戶也有可能分享與您有關的信息（包括位置數據和日誌信息）。特別是，我們的社交媒體服務，是專為使您與世界各地的用戶共享信息而設計，您可以使共享信息實時、廣泛地傳遞。只要您不刪除共享信息，有關信息會壹直留存在公共領域；即使您刪除共享信息，有關信息仍可能由其他用戶或不受我們控制的非關聯第三方獨立地緩存、復制或儲存，或由其他用戶或該等第三方在公共領域保存。',
      content44: '因此，請您謹慎考慮通過我們的服務上傳、發布和交流的信息內容。',
      content45:
        '在壹些情況下，您可通過我們某些服務的隱私設定來控制有權瀏覽您共享信息的用戶範圍。如要求從我們的服務中刪除您的相關信息，請通過該特別服務條款提供的方式操作。',
      content46:
        '某些個人信息因其特殊性可能被認為是敏感個人信息，例如您的種族、宗教、個人健康和醫療信息等。相比其他個人信息，敏感個人信息受到更加嚴格的保護。',
      content47:
        '請註意，您在使用我們的服務時所提供、上傳或發布的內容和信息（例如有關您社交活動的照片等信息），可能會泄露您的敏感個人信息。您需要謹慎地考慮，是否在使用我們的服務時披露相關敏感個人信息。',
      content48: '我們可能通過cookies收集和使用您的信息，並將該等信息儲存為日誌信息。',
      content49: '我們使用自己的cookies目的是為您提供更個性化的用戶體驗和服務，並用於以下用途：',
      content50:
        '1)住您的身份。例如：cookies有助於我們辨認您作為我們的註冊用戶的身份，或保存您向我們提供的有關您的喜好或其他信息；',
      content51:
        '2)分析您使用我們服務的情況。例如，我們可利用cookies來了解您使用TeamFace進行什麽活動，或哪些服務最受您的歡迎；',
      content52:
        '3)廣告優化。Cookies有助於我們根據您的信息，向您提供與您相關的廣告而非進行普遍的廣告投放。',
      content53:
        '我們為上述目的使用cookies的同時，可能將通過cookies收集的非個人身份信息，經統計加工後提供給廣告商或其他合作夥伴，用於分析用戶如何使用我們的服務，並用於廣告服務。',
      content54:
        '我們的產品和服務上可能會有廣告商或其他合作方放置的cookies。這些cookies可能會收集與您相關的非個人身份信息，以用於分析用戶如何使用該等服務、向您發送您可能感興趣的廣告，或用於評估廣告服務的效果。這些第三方cookies收集和使用該等信息，不受本《隱私政策》約束，而是受相關使用者的隱私政策約束，我們不對第三方的cookies承擔責任。',
      content55:
        '您可以通過瀏覽器設置拒絕或管理cookies。但請註意，如果停用cookies，您有可能無法享受最佳的服務體驗，某些服務也可能無法正常使用。同時，您還會收到同樣數量的廣告，但這些廣告與您的相關性會降低。',
      content56:
        '您在使用TeamFace時，我們可能使用您的信息向您的設備發送電子郵件、新聞或推送通知。如您不希望收到這些信息，可以按照我們的相關提示，在設備上選擇取消訂閱。',
      content57:
        '我們可能在必要時（例如因系統維護而暫停某壹項服務時）向您發出與服務有關的公告。您可能無法取消這些與服務有關、性質不屬於推廣的公告。',
      content58:
        '除某些特定服務外，我們所有的服務均適用本《隱私政策》。這些特定服務將適用特定的隱私政策。',
      content59: '針對某些特定服務的特定隱私政策，將更具體地說明我們在該等服務中如何使用您的信息。',
      content60: '該特定服務的隱私政策構成本《隱私政策》的壹部分。',
      content61: '如相關特定服務的隱私政策與本《隱私政策》有不壹致之處，適用該特定服務的隱私政策。',
      content62: '1)通過我們的服務而接入的第三方服務（包括任何第三方網站）收集的信息；',
      content63: '2)通過在我們服務中進行廣告服務的其他公司或機構所收集的信息。',
      content64: '我們可能適時修訂本《隱私政策》的條款，該等修訂構成本《隱私政策》的壹部分。',
      content65:
        '如該等修訂造成您在本《隱私政策》下權利的實質減少，我們將在修訂生效前通過在主頁上顯著位置提示或向您發送電子郵件或以其他方式通知您。在該種情況下，若您繼續使用我們的服務，即表示同意受經修訂的本《隱私政策》的約束。',
      content66:
        '4)設備或軟件信息，例如您的移動設備、網頁瀏覽器或用於接入我們服務的其他程序所提供的配置信息、您的MAC地址和移動設備所用的電信運營商、系統版本和設備的品牌及型號、識別碼等。',
      content67:
        '5)網絡接口報錯信息，您在使用我們的服務過程中產生的網絡報錯信息我們需要及時捕獲，以便更快的定位問題，提示您的使用體驗',
      content68: '6)集成第三方推送和地圖（如:小米推送、華為推送、極光推送、百度地圖、華為聯運 等）',
      content69:
        '5)集成第三方應用 為了更好的服務，進行及時消息提醒，位置地圖展現，給你的工作帶來方便快捷的操作。',
      content70: '6)獲取MAC地址為了系統安全和設備綁定，對的賬號安全和數據訪問安全做保障。'
    },
    termsService: '',
    rememberAccountpwd: '記住帳號密碼',
    wechatWorkLogin: '企業微信登錄',
    dingtalkLogin: '釘釘登錄',
    loginBrowserTip1: '建議使用',
    loginBrowserTip2: '谷歌',
    loginBrowserTip3: '瀏覽器'
  }
}
